export type ProductProcessingStage = 'queued' | 'analyzing' | 'generating' | 'ready' | 'failed';
export interface ProductProcessingJob {id:string;stage:ProductProcessingStage;updatedAt:string;error?:string}
export interface ProductProcessingRecord {identitySettings?:{productProcessing?:ProductProcessingJob}|null}
export function activeProductProcessing(row:ProductProcessingRecord,now=Date.now()):ProductProcessingJob|null {
 const job=row.identitySettings?.productProcessing;
 if(!job||!['queued','analyzing','generating'].includes(job.stage))return null;
 const age=now-new Date(job.updatedAt).getTime();
 return Number.isFinite(age)&&age<(job.stage==='queued'?2*60*60*1000:30*60*1000)?job:null;
}
export function productProcessingLabel(row:ProductProcessingRecord):string|null {
 const job=activeProductProcessing(row);
 return job?.stage==='queued'?'Queued…':job?.stage==='analyzing'?'Analyzing…':job?.stage==='generating'?'Generating product sheet…':null;
}
export function productProcessingError(row:ProductProcessingRecord):string|null {
 const job=row.identitySettings?.productProcessing;
 if(!job)return null;
 if(job.stage==='failed')return job.error||'Product processing failed. Please retry.';
 return job.stage!=='ready'&&!activeProductProcessing(row)?'Product processing was interrupted. Please retry.':null;
}
